<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='"All " + $store.state.icons.modules.notices.title'
            :titleIcon='$store.state.icons.modules.notices.icon'
            :titleIconColor='$store.state.icons.modules.notices.color'
            :showAdd='true'
            @add='edit'
            showHelp
            :helpText='helpText'
            helpWidth='700'
          >
          <!-- showAdd false for now until client/project filters in place and manual sending of notices built -->
            <v-data-table
              dense
              :headers='headers'
              :items='notices'
              :search='search'
              :loading='isLoading'
              no-data-text='No notices found'
              @click:row='openNotice'
              :items-per-page='-1'
            >
              <template v-slot:item.division='{ item }'>
                <wc-division-nai v-if='item.division' :division_obj='getDivisionObj(item.division)'></wc-division-nai>
              </template>
              <template v-slot:item.used_by='{ item }'>
                <span v-if='item.system_notice && item.stream_obj && item.location_obj'>{{ item.stream_obj.code + ' Staging' }}</span>
                <span v-if='item.system_notice && !(item.stream_obj && item.location_obj)'>System</span>
              </template>
              <template v-slot:item.name='{ item }'>
                <span v-if='!item.text' class='error--text'>{{ item.name }}</span>
                <span v-else>{{ item.name }}</span>
              </template>
              <template v-slot:item.description='{ item }'>
                <span class='caption grey--text'>{{ item.description }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click.stop="edit(item)">
                  mdi-pencil
                </v-icon>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <notice-details-dialog
      ref='noticeDialog'
      :showDialog='showDialog'
      :loading='isLoading'
      v-model='noticeCopy'
      @cancel='cancel'
      @save='save'
    ></notice-details-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import noticesAPI from '../api/'
import formRules from '@/mixins/formRules'
import miscServices from '@/services/misc'
import NoticeDetailsDialog from '../components/NoticeDetailsDialog'

export default {
  name: 'notices-dashboard',
  mixins: [formRules],
  props: {
  
  },
  data: () => ({
    isLoading: false,
    showDialog: false,
    noticeCopy: {},
    notices: [],
    search: "",
    headers: [
      { text: 'Division', value: 'division', width: '140' }, // 135 is JUST enough to fit "Construction"
      { text: 'Name', value: 'name', width: '350' },
      { text: 'Helpful Info', value: 'description' },
      { text: 'Used by', value: 'used_by', width: '120' }, // reverse lookup to see where in staging it's used
      { text: '', value: 'actions', width: '56', align: 'end', sortable: false, clickable: false }  // perhaps view/edit/use ?
    ],
    helpText: "<b>Welcome to the Notices area</b><br>" +
    "<br>Click on a notice to edit/view it.<br>" + 
    "System notices cannot be sent manually, but only when processing that particular staging location.<br>" +
    "System notices will have a 'Used by' value, to tell where/how CPM2 uses it.<br>" +
    "A Notice name in red indicates that there's no text in the notice yet<br>"+
    "<br>Archived Notices will not appear here.<br>If you archived a notice in error, please contact Westcap Solutions<br>" +
    "<br>Further improvements will be coming as we continue to develop this module<br>" +
    ""
  }),
  mounted () {
    this.getData()
  },
  computed: {

  },
  methods: {
    async getData() {
      console.log('getting data')
      this.isLoading = true
      let tmp = await noticesAPI.getNotices()
      this.notices = _.orderBy(_.filter(tmp, n => n.archived === false), ['division', 'name'])
      this.isLoading = false
    },
    openNotice (notice) {
      this.$router.push({ name: 'NoticeOverview', params: { id: notice.id } })
    },
    async save () {
      this.isLoading = true
       if (this.noticeCopy.id) {
        let tmp = await noticesAPI.updateNotice(this.noticeCopy)
        if (this.noticeCopy.archived) {
          this.notices = miscServices.removeObject(this.notices, tmp)
        } else {
          this.notices = miscServices.replaceObject(this.notices, tmp)
        }
      } else {
        let tmp = await noticesAPI.createNotice(this.noticeCopy)
        this.notices.push(tmp)
        this.notices = _.orderBy(this.notices, ['division', 'name'])
      }
      this.showDialog = false
      this.isLoading = false
    },
    edit (notice = null) {
      if (notice) {
        this.noticeCopy = _.cloneDeep(notice)
      } else {
        this.noticeCopy = {}
      }
      this.showDialog = true
      this.$refs.noticeDialog.resetValidate()
    },
    // copyNotice (notice) {
    //   // caution - this could cause editing problems/conflicts if division and/or location timeline options/mentions are changed. 
    //   this.noticeCopy = _.pick(notice, ['division', 'text'] )
    //   this.showDialog = true
    // },
    cancel () {
      this.$refs.noticeDialog.resetForm()
      this.showDialog = false
    },
    getDivisionObj (divisionID) {
      return _.find(this.$store.state.misc.divisions, d => d.id === divisionID)
    },
  },
  components: {
    'notice-details-dialog':NoticeDetailsDialog
  }
}
</script>